"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencySymbol = void 0;
var config_1 = require("../config");
var getCurrencySymbol = function (currency) {
    if (!currency)
        return '';
    return (config_1.currencySymbols === null || config_1.currencySymbols === void 0 ? void 0 : config_1.currencySymbols[currency]) || currency;
};
exports.getCurrencySymbol = getCurrencySymbol;
